/**
 * Generador de identificadores cortos y únicos para elementos locales
 * (capas añadidas, marcadores, etc.). No depende de librerías externas.
 */
export class IdGeneratorUtil {
  static generate(): string {
    return Math.random().toString(36).slice(2, 9);
  }
}